import classNames from 'classnames';
import React, { FocusEvent, KeyboardEvent, MouseEvent } from 'react';
import './Radio.scss';
import IRadioProps from './RadioProps';

const Radio = <T extends string = string>({
  value,
  name,
  onChange,
  onClick,
  onFocus,
  onBlur,
  onKeyDown,
  checked,
  label,
  disabled,
  className,
}: IRadioProps<T>) => {
  const classes = classNames(
    {
      radio: true,
      disabled,
    },
    className
  );

  function handleChange() {
    if (!disabled && onChange) {
      onChange(value);
    }
  }

  function handleClick(event: MouseEvent) {
    if (!disabled && onClick) {
      onClick(event);
    }
  }

  function handleFocus(event: FocusEvent) {
    if (!disabled && onFocus) {
      onFocus(event);
    }
  }

  function handleBlur(event: FocusEvent) {
    if (!disabled && onBlur) {
      onBlur(event);
    }
  }

  function handleKeyDown(event: KeyboardEvent) {
    if (!disabled && onKeyDown) {
      onKeyDown(event);
    }
  }

  return (
    <label className={classes}>
      <input
        type="radio"
        name={name}
        disabled={disabled}
        value={value}
        checked={checked}
        onChange={handleChange}
        onClick={handleClick}
        onFocus={handleFocus}
        onBlur={handleBlur}
        onKeyDown={handleKeyDown}
        className={classes}
      />
      <span className="radio-checkmark" />
      {label && <div className="radio-label">{label}</div>}
    </label>
  );
};

export default Radio;
